import { useEffect, useState } from 'react';
import { MailFolderDto, MailOutBoundConfigDTO } from '../../Types/MailT';
import { MailS } from '../MailS';

// eslint-disable-next-line import/prefer-default-export
export const useImapStore = (config: MailOutBoundConfigDTO, trigger?: number) => {
  const { id: configId } = config;
  const [defaultFolder, setDefaultFolder] = useState<MailFolderDto | null>();
  const [loadingFolder, setLoadingFolder] = useState(false);

  useEffect(() => {
    setLoadingFolder(true);
    MailS.getDefaultFolderIMAP(configId)
      .then(setDefaultFolder)
      .finally(() => setLoadingFolder(false));
  }, [configId, trigger]);

  return { defaultFolder, loadingFolder };
};
